module.exports = __webpack_public_path__ + "img/header-weddingRingsRedgold.bf606fb.jpg";